import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import routes from 'routesPaths';

interface Props {
  clearError: () => void;
  goBackLink: (() => void) | undefined;
  setIsPendingBack: (value: React.SetStateAction<boolean>) => void;
}

export const useResolveBack = ({ clearError, goBackLink, setIsPendingBack }: Props) => {
  const navigate = useNavigate();

  return useCallback(() => {
    clearError();

    if (goBackLink) {
      setIsPendingBack(true);
      goBackLink();
    } else {
      navigate(routes.home.path);
    }
  }, [goBackLink, navigate]);
};
